import service from '@/store/services/ventas-service';
import Jsona from 'jsona';

const jsona = new Jsona();

export const state = () => ({
  list: {},
  venta: {},
  meta: {},
  url: null
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, venta) => {
    state.venta = venta;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  }
};

export const actions = {
  list({commit, dispatch}, params = {}) {
    return service.list(params, this.$axios)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params, this.$axios)
      .then((venta) => { commit('SET_RESOURCE', venta); });
  },

  crearToken({commit, dispatch}, params) {
    return service.crearToken(params, this.$axios)
      .then((venta) => { commit('SET_RESOURCE', venta); });
  },
  
  autorizacion({commit, dispatch}, params) {
    return service.autorizacion(params, this.$axios)
      .then((venta) => { commit('SET_RESOURCE', venta); });
  },

  autorizacionToken({commit, dispatch}, params) {
    return service.autorizacionToken(params, this.$axios)
      .then((venta) => { commit('SET_RESOURCE', venta); });
  },

  verificacion({commit, dispatch}, params) {
    return service.verificacion(params, this.$axios)
      .then((venta) => { commit('SET_RESOURCE', venta); });
  },

  bloquear({commit, dispatch}, params) {
    return service.bloquear(params, this.$axios)
      .then((venta) => { commit('SET_RESOURCE', venta); });
  },

  seleccionar({commit, dispatch}, params) {
    return service.seleccionar(params, this.$axios)
      .then((venta) => { commit('SET_RESOURCE', venta); });
  },

  update({commit, dispatch}, params) {
    return service.update(params, this.$axios)
      .then((venta) => { commit('SET_RESOURCE', venta); });
  },

  add({commit, dispatch}, params) {
    return service.add(params, this.$axios)
      .then((venta) => { commit('SET_RESOURCE', venta); });
  },

  actualizarToken({commit, dispatch}, params) {
    return service.actualizarToken(params, this.$axios)
      .then((venta) => { commit('SET_RESOURCE', venta); });
  },
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.total, 
  crearToken: state => state.venta,
  actualizarToken: state => state.venta,
  add: state => state.venta,
  autorizacion: state => state.venta,
  autorizacionToken: state => state.venta,
  verificacion:state => state.venta,
  seleccionar: state => state.venta,
  bloquear: state => state.venta,
  venta: state => state.venta,
  url: state => state.url
};

const ventas = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default ventas;
